import React from 'react';

import { useWizard } from '../../AccomodationModal/hooks';
import * as types from './types';
import { useContentCreationHandlers } from './useContentCreationHandlers';

export const createContentWizardContext = React.createContext<types.TContentCreationWizardContext>(
  {} as types.TContentCreationWizardContext,
);

export const ContentCreationWizardContextProvider = ({
  children,
  initialValues,
}: React.PropsWithChildren<types.IContentCreationModalProps>) => {
  const [detailsFormProps, setDetailsFormProps] = React.useState<
    types.TContentCreationWizardContext['detailsFormProps']
  >({});
  const wizard = useWizard<types.TContentCreationWizardData>(['details', 'page'], {
    details: undefined,
    page: undefined,
  });

  const { handleDetailsSubmit, handlePageSubmit } = useContentCreationHandlers({ wizard });

  return (
    <createContentWizardContext.Provider
      value={{
        ...wizard,
        handlePageSubmit,
        handleDetailsSubmit,
        initialValues,

        detailsFormProps,
        setDetailsFormProps,
      }}
    >
      {children}
    </createContentWizardContext.Provider>
  );
};

export const useContentCreationWizardContext = () => React.useContext(createContentWizardContext);

export const withWizardContext = (WrappedComponent: React.ComponentType<types.ContentCreationModalProps>) => {
  return function (props: types.IContentCreationModalProps) {
    return (
      <ContentCreationWizardContextProvider {...props}>
        <WrappedComponent {...props} />
      </ContentCreationWizardContextProvider>
    );
  };
};
